import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from 'common/ApiUrls';
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { PortalNames, Portals } from "common/Portals";

import AP3Routes from "area/ap3/Layout/AP3Routes";
import BrokerRoutes from "area/broker/Layout/BrokerRoutes";
import ERUIRoutes from "area/employer/Layout/ERUIRoutes";
import EmployeeRoutes from "area/employee/Layout/EmployeeRoutes";
import ContractorRoutes from "area/contractor/Layout/ContractorRoutes";
import CCRoutes from "area/cui/Layout/CUIRoutes";
import CCUIRoutes from "area/ccui/Layout/CCUIRoutes";
import CVUIRoutes from "area/cvui/Layout/CVUIRoutes";
import ErrorPage from "pages/NotFound/ErrorPage";
import Logout from "pages/Auth/Logout";
import LandingPage from "pages/LandingPage";
import ReleaseNotes from "pages/ReleaseNotes";

function PrivateRoutes ({ updateTheme }) {
  const [companyId, setCompanyId] = useState("");
  const [insuredId, setInsuredId] = useState("");
  const [userInfo, setUserInfo] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentPortal, setCurrentPortal] = useState("");
  const [portals, setPortals] = useState(null);

  const [doShowError, setDoShowError] = useState(false);
  const [text, setText] = useState('');
  const [title, setTitle] = useState('');
  const error = {
    doShowError,
    setDoShowError,
    title,
    setTitle,
    text,
    setText
  }

  const [doShowFeedback, setDoShowFeedback] = useState(false);
  const [feedbackType, setFeedbackType] = useState('');
  const [feedbackSubject, setFeedbackSubject] = useState('');
  const feedback = {
    doShow: doShowFeedback,
    setDoShow: setDoShowFeedback,
    type: feedbackType,
    setType: setFeedbackType,
    subject: feedbackSubject,
    setSubject: setFeedbackSubject,
  };

  const [doShowClientAcknowledgement, setDoShowClientAcknowledgement] = useState(false);
  const [doShowDeliverablesAcknowledgement, setDoShowDeliverablesAcknowledgement] = useState(false);
  const [doShowBRDAcknowledgement, setDoShowBRDAcknowledgement] = useState(false);
  const [acknowledgements, setAcknowledgements] = useState(null);
  const acknowledgement = {
    doShowClientAcknowledgement,
    setDoShowClientAcknowledgement,
    doShowDeliverablesAcknowledgement,
    setDoShowDeliverablesAcknowledgement,
    doShowBRDAcknowledgement,
    setDoShowBRDAcknowledgement,
    acknowledgements,
    setAcknowledgements,
  }

  function getCompanyInfo(){
    console.log('getCompanyInfo')
    let companyId = localStorage.getItem(`selectedCompanyId`);
    if (companyId !== undefined && companyId != null) {
      apiGet(apiUrls.getUserInfo(companyId))
        .then((response) => {
          if (response.data.companyId) {
            setUserInfo(response.data);
          }
        });
    }
  }

  const setCompany = (id, companyType = null) => {
    if(companyType == "AP3" || companyType == "Prime"){
        localStorage.setItem(`selectedParentCompanyId`, id)
        localStorage.setItem(`selectedCompanyId`, id)
    }
    else if(companyType == "Broker"){
      localStorage.setItem(`selectedBrokerCompanyId`, id)
      localStorage.setItem(`selectedCompanyId`, id)
    }
    else{
        localStorage.setItem(`selectedCompanyId`, id)
    }
    setCompanyId(id)
    getCompanyInfo();
    setModalIsOpen(false)
  }

  useEffect(() => {
    let storedCurrentPortal = localStorage.getItem('currentPortal');

    if (storedCurrentPortal && storedCurrentPortal !== currentPortal) {
      setCurrentPortal(storedCurrentPortal);
    }
  }, []);

  useEffect(() => {
    apiGet(apiUrls.getRoles).then((response) => {
      let userRoles = response.data.map(d => d.applicationRoleCode);
      let matchingPortals = Portals.filter(r => r.Roles.filter(value => userRoles.includes(value)).length > 0);

      setPortals(matchingPortals);
    });
  }, []);

  useEffect(() => {
    if (currentPortal && portals !== null) {
      let storedCurrentPortal = localStorage.getItem('currentPortal');

      localStorage.setItem('currentPortal', currentPortal);
      var portal = portals.filter(p => p.Portal === currentPortal);

      if (portal.length === 1 && currentPortal !== storedCurrentPortal) {
        window.location.href = portal[0].Path;
      }
    }
  }, [currentPortal, portals]);

  useEffect(() => {
    if (insuredId) {
      apiGet(apiUrls.getUserInfo(insuredId))
      .then((response) => {
        if (response.data.insuredId) {
          setUserInfo(response.data);
        }
      });
    }
  },[insuredId])

  return (
    <>
      <Router >
        <PrivateRoutesContext.Provider value={{
          updateTheme: updateTheme,
          modalIsOpen: modalIsOpen,
          setModalIsOpen: setModalIsOpen,
          companyId: companyId,
          setCompany: setCompany,
          insuredId: insuredId,
          setInsuredId, setInsuredId,
          userInfo: userInfo,
          usesEase: companyId === "300209e9-4ac3-4d70-bb0b-1712116490fc" ? true : false,
          usesTpa: companyId === "300209e9-4ac3-4d70-bb0b-1712116490fc" ? true : false,
          usesTeams: companyId === "a579f785-cd14-461d-b6d2-09adc9d43564" ? true : false,
          currentPortal: currentPortal,
          setCurrentPortal: setCurrentPortal,
          portals: portals,
          setPortals: setPortals,
          error: error,
          feedback: feedback,
          acknowledgement: acknowledgement,
        }}>
          <Switch>
            <Route exact path="/logout" component={Logout} />
            <Route exact path="/landing" component={LandingPage} />
            <Route exact path="/release-notes" component={ReleaseNotes} />
            <Route path={`/${PortalNames.Partner.Path}`}>
              <AP3Routes />
            </Route>
            <Route path={`/${PortalNames.Broker.Path}`}>
              <BrokerRoutes />
            </Route>
            <Route path={`/${PortalNames.Employer.Path}`}>
              <ERUIRoutes portal={PortalNames.Employer.Name} />
            </Route>
            <Route path={`/${PortalNames.Employee.Path}`}>
              <EmployeeRoutes portal={PortalNames.Employee.Name} />
            </Route>
            <Route path={`/${PortalNames.Contractor.Path}`}>
              <ContractorRoutes portal={PortalNames.Contractor.Name} />
            </Route>
            <Route path={`/${PortalNames.CollectionPartner.Path}`}>
              <CCRoutes portal={PortalNames.CollectionPartner.Name} />
            </Route>
            <Route path={`/${PortalNames.CollectionCompany.Path}`}>
              <CCUIRoutes portal={PortalNames.CollectionCompany.Name} />
            </Route>
            <Route path={`/${PortalNames.CollectionVendor.Path}`}>
              <CVUIRoutes portal={PortalNames.CollectionVendor.Name} />
            </Route>
            
            <Route path="/" component={LandingPage} /> { /* redirect back to landing if nothing match */}
          </Switch>
        </PrivateRoutesContext.Provider>
      </Router>
    </>
  )
}

export default PrivateRoutes
